import { post, get, put, deleteApi } from './axiosFun';
// 课程评价新增
export const courseReviewAdd = (params) => { return post("/train/course-comment/add", params) };

// 课程评价详情
export const courseReviewDetails = (courseCommentId) => { return get(`/train/course-comment/detail/${courseCommentId}`) };

// 课程评价删除
export const courseReviewRemove = (courseCommentId) => { return deleteApi(`/train/course-comment/remove/${courseCommentId}`) };

// 课程评价分页
export const courseReviewPage = (params) => { return post(`/train/course-comment/page`,params) };

// 课程评价总数
export const courseReviewCount = (params) => { return post(`/train/course-comment/count`,params) };


// WEBPACK FOOTER //
// ./src/api/courseReview.js